module.exports = __webpack_public_path__ + "img/banner6.3b281aa3.jpg";